module.exports = __webpack_public_path__ + "img/poster-2.52fe26cd.jpg";